module.exports = __webpack_public_path__ + "static/media/W18-1222_AW_350_Teen_Desktop_Hero_2396x1473_fr.d4094cdb.jpg";